<template>
  <div class="max-w-4xl mx-auto p-5">
    <!-- Selection Area -->

    <div
      class="flex items-center gap-3 mb-5 bg-white border border-gray-300 rounded px-4 py-2 text-xs"
    >
      <select
        v-model="selectedItem"
        class="w-full h-8 rounded border border-gray-300 text-xs px-2"
      >
        <option disabled value="">Please select an item</option>
        <option v-for="item in itemList" :key="item.id" :value="item">
          {{ item.particular }}
        </option>
      </select>
      <button
        @click="addItem"
        class="px-3 py-1 text-white bg-blue-600 hover:bg-blue-700 rounded text-xs"
      >
        Add
      </button>
    </div>

    <!-- Selected Items List -->
    <div>
      <ul>
        <li
          v-for="(item, index) in selectedItems"
          :key="item.id"
          class="flex items-center justify-center gap-5 bg-white border border-gray-300 rounded px-4 py-3 text-xs mb-3"
        >
          <!-- Particular Name -->

          <!-- File Input -->
          <div class="flex-2">
            <input
              type="checkbox"
              v-model="item.isdocument"
              class="ml-2 text-xs"
            />
          </div>
          <div class="flex-[2]">
            {{ item.particular }}
          </div>
          <!-- Remove Button -->
          <div class="flex justify-end">
            <button
              @click="removeItem(item, index)"
              class="px-3 py-1 bg-red-600 hover:bg-red-700 text-white rounded text-xs"
            >
              Remove
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";

export default {
  props: {
    formData: Object,
    errors: Object,
    ifCurrentMode: String,
  },
  setup(props) {
    const removeItems = ref([]);
    const itemList = ref([
      { id: 1, particular: "Medical Certificate" },
      { id: 2, particular: "Clinical Abstract" },
      { id: 3, particular: "SOA (PHIC Deduction)" },
      { id: 4, particular: "O.R. (Original Copy)" },
      { id: 5, particular: "Surgical Report" },
      { id: 6, particular: "Police Report" },
      { id: 7, particular: "Incident Report" },
    ]);

    const selectedItem = ref(null);
    const selectedItems = computed(() => {
      return props.formData.AttachmentFiles;
    });
    const addItem = () => {
      if (
        selectedItem.value &&
        !selectedItems.value.some((item) => item.id === selectedItem.value.id)
      ) {
        selectedItems.value.push({ ...selectedItem.value, isdocument: false });
        selectedItem.value = null;
      }
    };

    const removeItem = (item, index) => {
      selectedItems.value.splice(index, 1);
      removeItems.value.push(item); // Add removed item to array
    };

    return {
      itemList,
      selectedItem,
      selectedItems,
      addItem,
      removeItem,
      removeItems,
    };
  },
};
</script>
